/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Image } from 'react-bootstrap';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useNavigate } from 'react-router-dom';
import * as S from './styles';
export interface ICardWidgetProps {
  title?: string;
  value?: string;
  period?: string;
  country?: string;
  bgColor?: string;
  boxShadow?: string;
  link?: string;
  noProgress?: boolean;
  icon?: string | any;
  color?: string | any;
  total?: string | any;
}

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export const CardWidget = ({
  title,
  value,
  period,
  country,
  icon,
  color,
  total,
  noProgress,
  bgColor,
  link,
  boxShadow,
}: ICardWidgetProps) => {
  const navigate = useNavigate();
  const _getIcon = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === 'string') {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image
            key={`image-icon`}
            src={Icon}
            width={60}
            height={60}
            className="icon icon-xxs text-gray-500 me-1"
          />
        );
      } else {
        const HeroIcon = require('@heroicons/react/solid');
        const NavIcon = HeroIcon[Icon];
        if (NavIcon) {
          _icon.push(
            <NavIcon
              key={`hero-icon`}
              src={Icon}
              className="icon icon-xxs text-gray-500 me-1"
            />
          );
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(
        <Icon
          key={`hero-icon-2`}
          className="icon icon-xxs text-gray-500 me-1"
        />
      );
    }
    return _icon;
  };
  const _renderTitleIf = () => {
    if (title) {
      return (
        <h2 className="fs-5 fw-bold" style={{ color: color }}>
          {title}
        </h2>
      );
    }
  };
  const _renderValueIf = () => {
    if (value || value + 1) {
      return (
        <h5
          className="fs-2 fw-extrabold mb-1"
          // style={{ color: bgColor ? 'white' : 'black' }}
        >
          {value}
        </h5>
      );
    }
  };
  const _renderLine = () => {
    console.log('wwidth', `${20 * value?.length}px`, title, value);
    return (
      <div
        style={{
          height: '5px',
          width: `${20 * (value + '')?.length}px`,
          backgroundColor: `#104382`,
          borderRadius: '1rem',
        }}
      ></div>
    );
  };
  const _renderPeriodIf = () => {
    if (period) {
      return (
        <div className="d-flex align-items-center">
          <span className="me-3">{period}</span>
          {icon && _getIcon(icon)}
          {country && <span>{country}</span>}
        </div>
      );
    }
  };
  return (
    <>
      {title && (
        <S.MyCard
          onClick={() => navigate(link)}
          isShadow={!!boxShadow}
          border="0"
          style={{
            backgroundColor: bgColor ?? 'white',
            height: '100%',
            cursor: link ? 'pointer' : 'auto',
            boxShadow: '0px 0px 10px lightgray',
            overflow:'hidden',

          }}
        >
          <Card.Body style={{ display: 'flex' }}>
            {noProgress ? (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
              >
                {_renderTitleIf()}
                <div>
                  {_renderValueIf()}
                  {_renderPeriodIf()}
                  {_renderLine()}
                </div>
              </div>
            ) : (
              <>
                <div
                  style={{
                    width: '70%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  {_renderTitleIf()}
                  <div>
                    {_renderValueIf()}
                    {_renderPeriodIf()}
                    {_renderLine()}
                  </div>
                </div>
                <div
                  style={{
                    width: '30%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {/* <CircularProgressBar color={`${color}`} value={80} size={350} title='total' subtitle='count' /> */}
                  <div>
                    <CircularProgressbar
                      styles={buildStyles({
                        textColor: `#104382`,
                        pathColor: `#104382`,
                        transition: 'stroke-dashoffset 4.5s ease 0s',
                      })}
                      value={((100 * value) / (total ? total : 100)).toFixed(0)}
                      text={`+${((100 * value) / (total ? total : 100)).toFixed(
                        0
                      )}%`}
                    />
                  </div>
                </div>
              </>
            )}
          </Card.Body>
         
          <div
            style={{
              backgroundColor: 'lightgray',
              marginLeft: 'auto',
              width: '40px',
              height: '60px',
              marginTop:'-60px',
              transform:'rotate(60deg)',
              overflow:'hidden',
              position:'relative',
              top:'35px',
              left:'8px',
              
            }}
          ></div>
        </S.MyCard>
      )}
    </>
  );
};

CardWidget.defaultProps = {};
